import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";

class Forbidden extends Component {
  state = {};
  render() {
    return (
      <div className="">
        <div className="">
          <p className="forgotPasswordMessage">
            <p
              style={{
                color: "red",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FontAwesomeIcon size="3x" icon={faUserLock} />
            </p>
            Whoa there! Sorry, but you don't have access to this page.
          </p>
          <p style={{ textAlign: "center" }}></p>
          <p style={{ textAlign: "center" }}></p>
        </div>
      </div>
    );
  }
}

export default Forbidden;



// WEBPACK FOOTER //
// ./src/template/private/Forbidden.js